import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import SmartLink from "../fragments/SmartLink";
import Image from "../fragments/Image";
import { useReveal } from '../hooks/UseReveal';

import "swiper/css";
import "swiper/css/pagination";

import Thumbnail from "../fragments/Thumbnail";
import SpecialText from "../fragments/SpecialText";

export default function RelatedPosts({ block }) {

	const swiperRef = useRef(null);
	const revealRef = useReveal({ once: true });

	if (!block || !block.posts || block.posts.length === 0) return null;

	return (
		<div id={block.section_id} className="c-page__block c-page__block--related-posts">
			<div className="c-related-posts">
				<div className="l-grid c-transition-in" ref={revealRef}>
					<div className="l-grid__col">
						<h2 className="c-related-posts__heading c-heading">
							<SpecialText text={block.heading || 'Related Posts'} />
						</h2>
					</div>
					<div className="l-grid__col">
						<Swiper
							slidesPerView={1}
							spaceBetween={16}
							breakpoints={{
								560: {
									slidesPerView: 2,
									spaceBetween: 24,
								},
								1280: {
									slidesPerView: 3,
									spaceBetween: 28,
								},
							}}
							grabCursor={true}
							onSwiper={(s) => (swiperRef.current = s)}
							className="c-related-posts__swiper"
						>
							{block.posts.map((post, index) => {
								const location = post.location?.[0]?.text || '';
								const category = post.category?.[0]?.text || '';
								
								return (
									<SwiperSlide key={index}>
										<Thumbnail post={post} />
									</SwiperSlide>
								);
							})}
						</Swiper>
						<div className="c-related-posts__cta">
							<h2 className="c-related-posts__cta__heading">
								<span><SpecialText text={'Let’s collaborate to bring '} /></span>
								<span><SpecialText text={'passionate projects to life. '} /></span>
							</h2>
							<SmartLink 
								link={'/contacts'} 
								className="c-related-posts__cta__button"
							>
								Get In Touch Today
							</SmartLink>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
} 